import type { EnvCountries } from "../types/env.types";

type EnvWeb = {
  /** Countries enabled for hosting in this environment. */
  countries?: EnvCountries;
  is_vat_enabled?: boolean;
  /** Peerspace's own registered addresses and tax numbers, keyed by country. */
  ps_addresses?: Record<string, Record<string, string> | undefined>;
};

type EnvState = {
  env: {
    isFetching: boolean;
    web?: EnvWeb;
  };
};

const selectEnvWeb = (state: EnvState) => state.env?.web;

/** Countries enabled for hosting in this environment. */
const selectEnvCountries = (state: EnvState): EnvCountries =>
  state.env?.web?.countries ?? {};

const selectIsVatEnabled = (state: EnvState) =>
  Boolean(state.env?.web?.is_vat_enabled);

export { selectEnvCountries, selectEnvWeb, selectIsVatEnabled };

export type { EnvState, EnvWeb };
